import { Box } from "@mui/system";

interface RegisterStepper {
  steps: string[];
  activeStep: number;
}

const Stepper: React.FC<RegisterStepper> = ({ steps, activeStep }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "start",
        gap: 1,
        mt: 4,
        width: "100%",
      }}
    >
      {steps.map((_, index) => {
        let dotColor;
        if (index === activeStep) {
          dotColor = "linear-gradient(90deg, #2A0091 0%, #744DFF 100%)";
        } else if (index < activeStep) {
          dotColor = "#2A0190";
        } else {
          dotColor = "#3D3D3D";
        }

        return (
          <Box
            key={index}
            sx={{
              width: activeStep === index ? 56 : 26,
              height: 7,
              borderRadius: "5px",
              background: dotColor,
              transition: "all 0.3s ease-in-out",
            }}
          />
        );
      })}
    </Box>
  );
};

export default Stepper;
